import * as React from 'react'
import { connect, ConnectedProps } from 'react-redux'
import { NavigateFunction, useNavigate, useParams } from 'react-router-dom'

import type { RecipientList } from 'types/list'

import DocumentHeadTags from 'components/document-head-tags'
import Modal from 'components/ui/disco-modal'

// TODO: Define new routes file for app2 and move page component composition there
import ContactsMailingLists from 'pages/contacts/mailing-lists'

import MailingListForm from './form'

class ContactsMailingListEdit extends React.Component<{
  navigate: NavigateFunction
  list: RecipientList
  params: {
    listId?: string
  }
}> {
  _onClose = () => {
    const { list } = this.props
    this.props.navigate(list ? `/lists/${list.id}` : '/contacts/list')
  }

  render() {
    const { params } = this.props
    let title

    if (params.listId) {
      title = 'Edit Mailing List'
    } else {
      title = 'Create Mailing List'
    }

    return (
      <>
        <DocumentHeadTags title={`${title} | DISCO`} />
        <Modal onRequestClose={this._onClose} isOpen>
          <MailingListForm formTitle={title} params={this.props.params} />
        </Modal>
      </>
    )
  }
}

const ConnectedContactsMailingListEdit = connect(
  null,
  {},
)(ContactsMailingListEdit)

function ContactsMailingListEditWithRouter(props) {
  const navigate = useNavigate()
  const params = useParams<{ listId?: string }>()
  return (
    <ConnectedContactsMailingListEdit
      {...props}
      navigate={navigate}
      params={params}
    />
  )
}

export default ContactsMailingListEditWithRouter as any
